import { ValueOf } from './util';

export const transactionAggregationCriterias = {
  DAILY: '日次',
  MONTHLY: '月次',
  YEARLY: '年次',
  WALLET_SERVICE: 'ウォレットサービス別',
  COMPANY: '企業別',
  SHOP: '店舗別',
  TERMINAL: '端末別',
} as const;

export type TransactionAggregationCriteriaKey = keyof typeof transactionAggregationCriterias;
export type TransactionAggregationCriteriaValue = ValueOf<typeof transactionAggregationCriterias>;

export const transactionAggregationCriteriaKeys = Object
  .keys(transactionAggregationCriterias) as TransactionAggregationCriteriaKey[];

/** v-select用items */
export const transactionAggregationCriteriaItems = transactionAggregationCriteriaKeys
  .map((key) => ({
    title: transactionAggregationCriterias[key],
    value: key,
  }));
